import { memo, useState } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { useBetslipStore } from '@/feature/betslip-pickem/hooks/use-betslip-store';
import { FantasyPickbar, PICK_BAR_BOTTOM_DISTANCE } from '@/feature/lobby/components/FantasyPickbar';

import { useSinglePlayerProfile } from '../SinglePlayerProfileProvider';
import { PickbarSheetSync } from './PickbarSheetSync';

/**
 * Pickbar for the *single* player profile sheet.
 * Appears after the sheet's mount animation completes, then translates in sync with sheet movement
 */
export const SinglePlayerProfilePickbar = memo(() => {
    const insets = useSafeAreaInsets();
    const hasPicks = useBetslipStore(state => state.betslip.length > 0);

    const { playerProfileAnimatedIndex } = useSinglePlayerProfile();

    // this is used to sync pickbar with the profile sheet visibility
    // we need to hide the pickbar when the sheet is closed
    const [isSinglePlayerSheetOpen, setIsSinglePlayerSheetOpen] = useState(false);

    const shouldShowPickbarOnSinglePlayerSheet = isSinglePlayerSheetOpen && hasPicks;

    return (
        <PickbarSheetSync animatedYIndex={playerProfileAnimatedIndex} onSheetOpenChange={setIsSinglePlayerSheetOpen}>
            <FantasyPickbar
                showContent={shouldShowPickbarOnSinglePlayerSheet}
                visiblePosition={insets.bottom + PICK_BAR_BOTTOM_DISTANCE}
            />
        </PickbarSheetSync>
    );
});
